import React, { useEffect, useState, useRef } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import axios from 'axios'

import { Grid, Box, Paper, Typography, Checkbox, TextField, Button } from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'

import Title from '../components/atoms/Title'
import CenteredSubmitButton from '../components/molecules/CenteredSubmitButton'
import TinyMCE from '../components/organisms/TinyMCE'

import { Event } from '../types/Event'

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    height: `100%`
  },
  textField: {
    paddingRight: theme.spacing(1)
  }
}))

const EventCMS: React.FC<RouteComponentProps<{ society_info_id: string }>> = ({
  match,
  history
}) => {
  const societyInfoId = match.params.society_info_id
  const currentPath = match.path
  const classes = useStyles({})
  const [societyInfo, setSocietyInfo] = useState<{
    title: string
    content: string
  }>({
    title: '',
    content: ''
  })
  const editorRef = useRef(null)
  const [type, setType] = useState<'create' | 'edit'>('create')

  /**
   * 初期化処理
   */
  useEffect(() => {
    const fetchSocietyInfo = async () => {
      const { data } = await axios.get<Event>(`/society-info/${societyInfoId}`)
      setSocietyInfo({
        title: data.title,
        content: data.content
      })
    }
    // 現在のパスから新規作成処理なのか、更新処理なのかを判断する
    if (currentPath === '/create-society-info') {
      setType('create')
    } else {
      setType('edit')
      fetchSocietyInfo()
    }
  }, [societyInfoId])

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    try {
      event.preventDefault()
      if (type === 'create') {
        // 新着情報を新規作成の場合
        await axios.post(`/society-info`, {
          ...societyInfo
        })
      } else {
        // 新着情報更新の場合
        await axios.put(`/society-info/${societyInfoId}`, {
          ...societyInfo
        })
      }
      history.push('/society-info')
    } catch (error) {
      alert(error.message)
    }
  }

  return (
    <React.Fragment>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Box display="flex" justifyContent="space-between">
            <Title>学会情報の新規作成／編集</Title>
            <Box ml={3}>
              <Button color="primary" variant="outlined" href="/society-info">
                一覧に戻る
              </Button>
            </Box>
          </Box>
          <form onSubmit={handleSubmit}>
            <Box mb={5}>
              <Grid container alignItems="center" spacing={3}>
                <Grid item xs={12} sm={2} md={1}>
                  <Typography variant="subtitle2">タイトル</Typography>
                </Grid>
                <Grid item xs={12} sm={10} md={11}>
                  <Box width={400}>
                    <TextField
                      required
                      value={societyInfo.title}
                      variant="outlined"
                      placeholder="タイトルを入力"
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                        setSocietyInfo({
                          ...societyInfo,
                          title: event.target.value
                        })
                      }
                      fullWidth
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>

            <Box my={3}>
              <Box>
                <TinyMCE
                  initialValue={societyInfo.content}
                  inputHandler={(tinyMCEContent: string) => {
                    setSocietyInfo({
                      ...societyInfo,
                      content: tinyMCEContent
                    })
                  }}
                  editorRef={editorRef}
                />
              </Box>
            </Box>
            <Box mb={10}>
              <CenteredSubmitButton
                submittable
                resettable
                submitHandler={() => {}}
                resetHandler={() => {
                  window.location.reload()
                }}
                size="large"
              />
            </Box>
          </form>
        </Paper>
      </Grid>
    </React.Fragment>
  )
}

export default EventCMS
